import LicenseLimitedModal, {
  LicenseLimitedModalPropsBase,
} from "@/components/modal/license-limited-modals/license-limited-modal";
import React from "react";
import { duetsLicenseManager } from "@/services/license/license-managers/duets-license-manager";

const DuetsCountLimitedModal = ({
  licenseName,
}: LicenseLimitedModalPropsBase) => {
  return (
    <LicenseLimitedModal
      licenseName={licenseName}
      upgradeToMessage={"generate duets"}
      allowsMessage={""}
      shouldNavigateToPricing={true}
      availableInHigherPlanConfig={{
        isAvailableInHigherPlan:
          !duetsLicenseManager.downloadResultLimiter.isDownloadEnabled(
            licenseName,
          ),
        serviceName: "Duets",
      }}
    />
  );
};

export default DuetsCountLimitedModal;
